import { createContext } from "react";

const InvestmentContext = createContext();

export default InvestmentContext;